/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { PagedAsyncIterableIterator } from "@azure/core-paging";
import { QuotaUsageResult, UsagesListBySubscriptionOptionalParams } from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a Usages. */
export interface Usages {
  /**
   * Get a list of all Azure AI Search quota usages across the subscription.
   * @param location The unique location name for a Microsoft Azure geographic region.
   * @param options The options parameters.
   */
  listBySubscription(
    location: string,
    options?: UsagesListBySubscriptionOptionalParams,
  ): PagedAsyncIterableIterator<QuotaUsageResult>;
}
